export default () => {
  const { $t } = useNuxtApp()
  const listStatus = [
    {
      value: 0,
      label: $t('labels.init')
    },
    {
      value: 1,
      label: $t('labels.send')
    },
    {
      value: 2,
      label: $t('labels.orderCreated')
    },
    {
      value: 3,
      label: $t('labels.cancel')
    }
  ]

  return listStatus
}
